import * as Yup from 'yup'
import { Form,  Col, Row } from 'react-bootstrap'
import { Options } from '../SelectOptions';
import { CustomFormSelect, CustomFormControl } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    becomingAwareThroughNotes: checkText(settings),
    additionalNotes: checkText(settings),
});

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formBecomingAwareThrough">
                <Form.Label>Wie bist du auf uns aufmerksam geworden?</Form.Label>
                <CustomFormSelect
                    colors={colors}
                    name="becomingAwareThrough"
                    value={values.becomingAwareThrough}
                    isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                    isInvalid={errors.becomingAwareThrough}
                    onChange={handleChange}
                    onBlur={handleBlur}
                >
                    <option value="">Bitte auswählen...</option>
                    {Options.BecomingAwareThrough.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                </CustomFormSelect>
                <Form.Control.Feedback type="invalid">
                    {errors.becomingAwareThrough}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBecomingAwareThroughNotes">
                <Form.Label>Bitte mache eine genauere Angabe, wenn du „Sonstiges“ angegeben hast</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Wenn du „Sonstiges“ angegeben hast: Wie bist du auf uns aufmerksam geworden?"
                    type="text"
                    name="becomingAwareThroughNotes"
                    value={values.becomingAwareThroughNotes}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.becomingAwareThroughNotes && !errors.becomingAwareThroughNotes}
                    isInvalid={touched.becomingAwareThroughNotes && errors.becomingAwareThroughNotes}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.becomingAwareThroughNotes}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formAdditionalNotes">
                <Form.Label>Was sollten wir sonst noch über dich wissen?</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Gib an, was wir sonst noch über dich wissen sollten"
                    type="text"
                    name="additionalNotes"
                    value={values.additionalNotes}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.additionalNotes && !errors.additionalNotes}
                    isInvalid={touched.additionalNotes && errors.additionalNotes}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.additionalNotes}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};